import React from "react";
import PropTypes from "prop-types";
import styles from "./PurchaseButton.module.css";
import purchasedIcon from "../../assets/Purchased_Icon_Green.png";
import notPurchasedIcon from "../../assets/Purchased_Icon_Gray.png";

export function PurchaseButton({ onClick, active, className }) {
  return (
    <div
      className={`${styles.container} ${className ? className : ""}`}
      onClick={onClick}
    >
      {active ? (
        <img
          src={purchasedIcon}
          alt="Green Purchased Button"
          className={styles.icon}
        />
      ) : (
        <img
          src={notPurchasedIcon}
          alt="Grey Purchased Button"
          className={styles.icon}
        />
      )}
    </div>
  );
}

PurchaseButton.propTypes = {
  onClick: PropTypes.func,
  active: PropTypes.bool,
};
